import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import CrossIcon from 'jl-design-system/elements/icons-jb/Close24PxOutlined';

import styles from './typeahead-overlay.scss';

const TypeaheadOverlay = ({ isTypeaheadOpen, onCloseButtonClick }) => {
  const transparentOverlayClasses = classNames(styles.transparentOverlay, {
    [styles.transparentOverlay__hidden]: !isTypeaheadOpen,
  });
  const whiteOverlayClasses = classNames(styles.whiteOverlay, {
    [styles.whiteOverlay__hidden]: !isTypeaheadOpen,
  });
  const closeButtonClasses = classNames(styles.closeButton, {
    [styles.closeButton__hidden]: !isTypeaheadOpen,
  });

  return (
    <>
      <div
        className={transparentOverlayClasses}
        data-testid="search-transparent-overlay"
      />
      <div className={whiteOverlayClasses} data-testid="search-white-overlay" />
      <button
        data-testid="close-expanded-search"
        className={closeButtonClasses}
        onClick={onCloseButtonClick}
      >
        <CrossIcon className={styles.closeIcon} />
        <p>Close</p>
      </button>
    </>
  );
};

TypeaheadOverlay.propTypes = {
  isTypeaheadOpen: PropTypes.bool.isRequired,
  onCloseButtonClick: PropTypes.func.isRequired,
};

export default TypeaheadOverlay;
